import { render, staticRenderFns } from "./profile-remove-child.vue?vue&type=template&id=4fa2df4b&"
import script from "./profile-remove-child.vue?vue&type=script&lang=js&"
export * from "./profile-remove-child.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports